/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Org_Source_Estimate_LongInputs */



/**
* | output |
* | --- |
* | "Estimate — the final invoice may differ" |
*
* @param {Partner_Org_Source_Estimate_LongInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_source_estimate_long = /** @type {((inputs?: Partner_Org_Source_Estimate_LongInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Source_Estimate_LongInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Schätzung — die endgültige Rechnung kann abweichen")
	return /** @type {LocalizedString} */ ("Estimate — the final invoice may differ")
});